import { shade } from 'polished'
import styled from 'styled-components'

import { applyButtonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const PendingButtonStyled = styled(BaseButton)`
  ${(props) => applyButtonColorCSS(shade(0.1, props.theme.colors.warning))}
`
